import PaymentTypes from '@/models/PaymentTypes.js';

export default {
    getPaymentMethodTranslationParameterName(paymentType) {
        switch(paymentType) {
        case PaymentTypes.CREDIT_CARD:
            return 'creditCard';
        case PaymentTypes.BOLETO:
            return 'boleto';
        case PaymentTypes.DEBIT_CARD:
            return 'debitCard';
        case PaymentTypes.PIX:
            return 'pix';
        case PaymentTypes.QRCODE:
            return 'qrCodePay';
        case PaymentTypes.VOUCHER:
            return 'voucher';
        case PaymentTypes.QRCODE_DEBIT:
            return 'qrCodeDebit';
        case PaymentTypes.CLICK_TO_PAY:
            return 'clickToPay';
        case PaymentTypes.MULTIBENEFITS:
            return 'multibenefitsCard';
        case PaymentTypes.GOOGLE_PAY:
            return 'googlePay';
        case PaymentTypes.APPLE_PAY:
            return 'applePay';
        case PaymentTypes.PIX_OPEN_FINANCE:
            return 'pixOpenFinance';
        }
    }
};